import { render, staticRenderFns } from "./PublicView.vue?vue&type=template&id=62b6fd8a&scoped=true&"
import script from "./PublicView.vue?vue&type=script&lang=js&"
export * from "./PublicView.vue?vue&type=script&lang=js&"
import style0 from "./PublicView.vue?vue&type=style&index=0&id=62b6fd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6fd8a",
  null
  
)

export default component.exports